import { initializeApp } from 'firebase/app';
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  connectAuthEmulator,
  initializeAuth,
} from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';
import { environment } from './enviroments';
import { FirebaseAuthentication, Persistence } from '@capacitor-firebase/authentication';
import { isPlatform } from '@ionic/react';

const firebaseApp = initializeApp(environment.FIREBASE_CONFIG);
export const firestore = getFirestore(firebaseApp);

export const authInstance = initializeAuth(firebaseApp, {
  persistence: [browserLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});
if (!isPlatform('hybrid')) {
  FirebaseAuthentication.setPersistence({ persistence: Persistence.BrowserLocal });
}

if (import.meta.env.VITE_AUTH_EMULATOR_URL && import.meta.env.VITE_STORAGE_EMULATOR_PORT && import.meta.env.DEV) {
  const storage = getStorage(firebaseApp);

  try {
    connectAuthEmulator(authInstance, import.meta.env.VITE_AUTH_EMULATOR_URL);
    connectStorageEmulator(storage, '127.0.0.1', import.meta.env.VITE_STORAGE_EMULATOR_PORT);
    connectFirestoreEmulator(firestore, '127.0.0.1', import.meta.env.VITE_FIRESTORE_EMULATOR_PORT);
  } catch (error) {
    console.error(error);
  }
}

// Get RemoteConfig instance
export const remoteConfig = getRemoteConfig(firebaseApp);
